import React, { Component } from "react";
import { Collapse, Well } from "react-bootstrap";
import moment from "moment";
import AddContactos from "./sub_components/add_contactos";
import Select from "react-select";
import FormatoDireccion from "./sub_components/formatoDireccion";
import ModalDireccion from "../common/scripts/modalDirecciones";
import { colourStyles } from "../common/scripts/react-select-styles";

export default class Sintomas extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      contactosTableContinue: null,
      departamentosList: this.props.departamentosList,
      departamentoSelected: null,
      ciudadesList: [],
      ciudadSelected: null,
      showDireccion: false,
      visibleSelectorDocumento: false,
      visibleSelectorDocumento2: false,
      visibleSelectorIps: false,
      visibleSelectorMedicoDocumento: false,
    };
    this.handleContactosTable = this.handleContactosTable.bind(this);
    this.handleGenericHtml = this.handleGenericHtml.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCiudad = this.handleCiudad.bind(this);
  }

  handleContactosTable(allowedToContinue) {
    this.setState({ contactosTableContinue: !allowedToContinue });
  }

  handleGenericHtml(text) {
    return { __html: text };
  }

  handleChange(selectedOption) {
    this.setState(
      { departamentoSelected: selectedOption, ciudadSelected: null },
      () => {
        this.props.handleInput(event, selectedOption, "Departamento");
        this.props.getDepartamentos(true, selectedOption.value);
      }
    );
  }

  handleCiudad(selectedOption) {
    this.setState({ ciudadSelected: selectedOption });
    this.props.handleInput(event, selectedOption, "Ciudad");
  }

  handleDireccionSubmit(direccion, observaciones) {
    this.props.handleDireccion(direccion, observaciones);
    this.setState({ showDireccion: false });
  }

  render() {
    const { departamentoSelected, ciudadSelected } = this.state;
    let fechacontacto =
      pregunta1 == true
        ? this.props.fechaRelacionContacto == null
          ? true
          : null
        : null;
    let nombre,
      id,
      idNum,
      email,
      emailIsValid,
      celular,
      direccion,
      barrio,
      ciudad,
      localidad,
      fecha,
      fechaRelacionContacto,
      idList,
      pregunta1,
      pregunta2,
      pregunta3,
      aceptaTC,
      collapse,
      ipsList,
      ips,
      medicoDocument,
      medicoDocumentNum,
      showForm,
      disabled,
      embarazo,
      semanasGestacion,
      departamento;
    [
      nombre,
      id,
      idNum,
      email,
      emailIsValid,
      celular,
      direccion,
      barrio,
      ciudad,
      localidad,
      fecha,
      fechaRelacionContacto,
      idList,
      pregunta1,
      pregunta2,
      pregunta3,
      aceptaTC,
      collapse,
      ipsList,
      ips,
      medicoDocument,
      medicoDocumentNum,
      showForm,
      disabled,
      embarazo,
      semanasGestacion,
      departamento,
    ] = [
      this.props.nombre,
      this.props.documentSelected.CSDocumentoIdentidadText,
      this.props.numeroDocumento,
      this.props.email,
      this.props.emailIsValid,
      this.props.celular,
      this.props.direccion,
      this.props.barrio,
      this.props.ciudad,
      this.props.localidad,
      this.props.fecha,
      this.props.fechaRelacionContacto,
      this.props.documentos,
      this.props.form1Pregunta1,
      this.props.form1Pregunta2,
      this.props.form1Pregunta3,
      this.props.aceptaTerminosCondiciones,
      this.props.collapse,
      this.props.ipsList,
      this.props.ips,
      this.props.medicoDocumentSelected,
      this.props.numeroDocumentoMedico,
      this.props.showForm,
      this.props.disabled,
      this.props.embarazo,
      this.props.semanasGestacion,
      this.props.departamento,
    ];
    return (
      <section
        className="tab-pane fade form-container formularioSolicitud mainContent"
        id="nav-sintoma"
        role="tabpanel"
        aria-labelledby="nav-profile-tab"
      >
        <div>
          <ModalDireccion
            msg={
              <FormatoDireccion
                direccion={this.handleDireccionSubmit.bind(this)}
              />
            }
            showModal={this.state.showDireccion}
          />
          <div>
            <h3>{i18next.t("forms.form1Titulo")}</h3>
            <br></br>
            <form onSubmit={(e) => e.preventDefault()}>
              <h4>{i18next.t("forms.form1subtitulo")}</h4>
              <h4 className="formularioSolicitud--subtitulo2">
                {i18next.t("forms.form1subtitulo2")}
              </h4>
              <br></br>

              <div className="form-group row">
                <div className="col-sm-4">
                  <p className="col-form-label formularioSolicitud--text-aligned formularioSolicitud--label">
                    {i18next.t("forms.cedula")}
                  </p>
                  <p className="formularioSolicitud--text-aligned">
                    {i18next.t("forms.cedulaIndicacion")}
                  </p>
                </div>
                <div className="col-sm-3">
                  <button
                    style={{ cursor: "pointer" }}
                    disabled={false}
                    className="dropdown-toggle formularioSolicitud--dropDown"
                    // type="button"
                    id="dropdownCedula"
                    // data-toggle="dropdown"
                    // aria-haspopup="true"
                    // aria-expanded="true"
                    onClick={() =>
                      this.setState({
                        visibleSelectorDocumento:
                          !this.state.visibleSelectorDocumento,
                      })
                    }
                  >
                    <div>
                      <p className="text-left">{id}</p>
                    </div>
                    <span className="caret"></span>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="dropdownCedula"
                      style={{
                        cursor: "pointer",
                        display: `${
                          this.state.visibleSelectorDocumento
                            ? "block "
                            : "none"
                        }`,
                      }}
                    >
                      {idList?.map((item, index) => {
                        return (
                          <li
                            key={index}
                            onClick={() => {
                              this.setState({
                                visibleSelectorDocumento: false,
                              });
                              this.props.updateocumentSelected(item);
                            }}
                          >
                            <p>{item.CSDocumentoIdentidadText}</p>
                          </li>
                        );
                      })}
                    </ul>
                  </button>
                </div>
                <div className="col-sm-5">
                  <input
                    style={{ cursor: "pointer" }}
                    disabled={false}
                    type="text"
                    className={
                      idNum == "" || idNum == " "
                        ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                        : "form-control formularioSolicitud--input"
                    }
                    value={idNum}
                    onChange={() => this.props.handleInput(event)}
                    name="NumeroDocumento"
                    maxLength={33}
                  />
                  {idNum == "" || idNum == " " || idNum == null ? (
                    <p className="formularioSolicitud--input-errorLabel">
                      {i18next.t("forms.cedulaError")}
                    </p>
                  ) : null}
                </div>

                <div className="row">
                  <div className="col-sm-12 text-center">
                    <button
                      type="submit"
                      className="btn btn-default"
                      disabled={
                        id == "elija un documento" ||
                        idNum == "" ||
                        idNum == " " ||
                        idNum == null
                          ? true
                          : false
                      }
                      onClick={(event) => this.props.consultarRieso(event)}
                    >
                      Consultar
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <hr />
            {showForm ? (
              <div>
                <form>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                      {i18next.t("forms.nombre")}
                    </label>
                    <div className="col-sm-8">
                      <input
                        style={{ cursor: "pointer" }}
                        type="text"
                        className={
                          nombre == "" || nombre == " "
                            ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                            : "form-control formularioSolicitud--input"
                        }
                        value={nombre}
                        onChange={() => this.props.handleInput(event)}
                        onFocus={() => this.props.handleInput(event)}
                        name="Nombre"
                      />
                      {nombre == "" || nombre == " " || nombre == null ? (
                        <p className="formularioSolicitud--input-errorLabel">
                          {i18next.t("forms.nombreError")}
                        </p>
                      ) : null}
                    </div>
                  </div>

                  <div className="form-group row">
                    <div className="col-sm-4">
                      <p className="col-form-label formularioSolicitud--text-aligned formularioSolicitud--label">
                        {i18next.t("forms.cedula")}
                      </p>
                      <p className="formularioSolicitud--text-aligned">
                        {i18next.t("forms.cedulaIndicacion")}
                      </p>
                    </div>
                    <div className="col-sm-3">
                      <button
                        disabled={false}
                        style={{ cursor: "pointer" }}
                        className="dropdown-toggle formularioSolicitud--dropDown"
                        // type="button"
                        id="dropdownCedula"
                        // data-toggle="dropdown"
                        // aria-haspopup="true"
                        // aria-expanded="true"
                        onClick={() =>
                          this.setState({
                            visibleSelectorDocumento2:
                              !this.state.visibleSelectorDocumento2,
                          })
                        }
                      >
                        <div>
                          <p className="text-left">{id}</p>
                        </div>
                        <span className="caret"></span>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="dropdownCedula"
                          style={{
                            cursor: "pointer",
                            display: `${
                              this.state.visibleSelectorDocumento2
                                ? "block "
                                : "none"
                            }`,
                          }}
                        >
                          {idList?.map((item, index) => {
                            return (
                              <li
                                key={index}
                                onClick={() => {
                                  this.setState({
                                    visibleSelectorDocumento2: false,
                                  });
                                  this.props.updateocumentSelected(item);
                                }}
                              >
                                <p>{item.CSDocumentoIdentidadText}</p>
                              </li>
                            );
                          })}
                        </ul>
                      </button>
                    </div>
                    <div className="col-sm-5">
                      <input
                        style={{ cursor: "pointer" }}
                        disabled={false}
                        type="text"
                        className={
                          idNum == "" || idNum == " "
                            ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                            : "form-control formularioSolicitud--input"
                        }
                        value={idNum}
                        onChange={() => this.props.handleInput(event)}
                        name="NumeroDocumento"
                        maxLength={33}
                      />
                      {idNum == "" || idNum == " " || idNum == null ? (
                        <p className="formularioSolicitud--input-errorLabel">
                          {i18next.t("forms.cedulaError")}
                        </p>
                      ) : null}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                      {i18next.t("forms.telefono")}
                    </label>
                    <div className="col-sm-8">
                      <input
                        style={{ cursor: "pointer" }}
                        type="text"
                        className={
                          celular == "" || celular == " "
                            ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                            : "form-control formularioSolicitud--input"
                        }
                        value={celular}
                        onChange={() => this.props.handleInput(event)}
                        name="Celular"
                        maxLength={13}
                      />
                      {celular == "" || celular == " " || celular == null ? (
                        <p className="formularioSolicitud--input-errorLabel">
                          {i18next.t("forms.telefonoError")}
                        </p>
                      ) : null}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                      {i18next.t("forms.email")}
                    </label>
                    <div className="col-sm-8">
                      <input
                        style={{ cursor: "pointer" }}
                        type="text"
                        className={
                          email == "" || email == " "
                            ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                            : "form-control formularioSolicitud--input"
                        }
                        value={email}
                        onChange={() => this.props.handleInput(event)}
                        // onFocus={() => this.props.handleInput(event)}
                        name="Email"
                      />
                      {email == "" ||
                      email == " " ||
                      email == null ||
                      emailIsValid == false ? (
                        <p className="formularioSolicitud--input-errorLabel">
                          {i18next.t("forms.emailError")}
                        </p>
                      ) : null}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                      {i18next.t("forms.direccion")}
                    </label>
                    <div className="col-sm-8">
                      <input
                        style={{ cursor: "pointer" }}
                        type="text"
                        className={
                          direccion == "" || direccion == " "
                            ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                            : "form-control formularioSolicitud--input"
                        }
                        value={direccion}
                        // onChange={() => this.props.handleInput(event)}
                        // onFocus={() => this.props.handleInput(event)}
                        onChange={() => this.setState({ showDireccion: true })}
                        name="Direccion"
                      />
                      {direccion == "" ||
                      direccion == " " ||
                      direccion == null ? (
                        <p className="formularioSolicitud--input-errorLabel">
                          {i18next.t("forms.direccionError")}
                        </p>
                      ) : null}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                      {i18next.t("forms.departamento")}
                    </label>
                    <div className="col-sm-8">
                      <Select
                        placeholder={"Seleccione una opción"}
                        value={departamentoSelected}
                        onChange={this.handleChange}
                        options={this.props.departamentosList}
                        styles={colourStyles}
                      />
                      {departamento == "" ||
                      departamento == " " ||
                      departamento == null ? (
                        <p className="formularioSolicitud--input-errorLabel">
                          {i18next.t("forms.departamentoError")}
                        </p>
                      ) : null}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                      {i18next.t("forms.ciudad")}
                    </label>
                    <div className="col-sm-8">
                      <Select
                        placeholder={"Seleccione una opción"}
                        value={ciudadSelected}
                        onChange={this.handleCiudad}
                        options={this.props.ciudadesList}
                        styles={colourStyles}
                        isDisabled={
                          departamentoSelected === null ? true : false
                        }
                      />
                      {ciudad == "" || ciudad == " " || ciudad == null ? (
                        <p className="formularioSolicitud--input-errorLabel">
                          {i18next.t("forms.ciudadError")}
                        </p>
                      ) : null}
                    </div>
                  </div>

                  {/* <div className="form-group row">
                                        <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">{i18next.t("forms.ciudad")}</label>
                                        <div className="col-sm-8">
                                            <input
                                                type="text"
                                                className={ciudad == "" || ciudad == " " ? "form-control formularioSolicitud--input formularioSolicitud--input-error " : "form-control formularioSolicitud--input"}
                                                value={ciudad}
                                                onChange={() => this.props.handleInput(event)}
                                                onFocus={() => this.props.handleInput(event)}
                                                name="Ciudad" />
                                            {ciudad == "" || ciudad == " " || ciudad == null ? <p className="formularioSolicitud--input-errorLabel">{i18next.t("forms.ciudadError")}</p> : null}
                                        </div>
                                    </div> */}

                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                      {i18next.t("forms.localidad")}
                    </label>
                    <div className="col-sm-8">
                      <input
                        style={{ cursor: "pointer" }}
                        type="text"
                        className={
                          localidad == "" || localidad == " "
                            ? "form-control formularioSolicitud--input  "
                            : "form-control formularioSolicitud--input"
                        }
                        value={localidad}
                        onChange={() => this.props.handleInput(event)}
                        onFocus={() => this.props.handleInput(event)}
                        name="Localidad"
                      />
                      {/* {localidad == "" || localidad == " " || localidad == null ? <p className="formularioSolicitud--input-errorLabel">Digíte una localidad válida</p> : null} */}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                      {i18next.t("forms.fechaSintomas")}
                    </label>
                    <div className="col-sm-8">
                      <input
                        style={{ cursor: "pointer" }}
                        type="date"
                        max={moment().format("YYYY-MM-DD")}
                        name="Fecha"
                        value={fecha}
                        className={
                          fecha > moment().format("YYYY-MM-DD")
                            ? "formularioSolicitud--date formularioSolicitud--dropDown formularioSolicitud--input formularioSolicitud--input-error"
                            : "formularioSolicitud--date formularioSolicitud--dropDown formularioSolicitud--input"
                        }
                        onChange={() => this.props.handleInput(event)}
                        onFocus={() => this.props.handleInput(event)}
                      />
                      {fecha > moment().format("YYYY-MM-DD") ? (
                        <p className="formularioSolicitud--input-errorLabel">
                          {i18next.t("forms.errorFecha")}
                        </p>
                      ) : null}
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-sm-12 col-form-label formularioSolicitud--text-aligned">
                      {i18next.t("forms.form1EmbarazoPregunta")}
                    </label>
                    <div className="col-sm-12 col-form-label formularioSolicitud--text-aligned ">
                      <div className="form-check form-check-inline">
                        <label className="form-check-label">Si</label>
                        <input
                          style={{ cursor: "pointer" }}
                          checked={embarazo}
                          onClick={() =>
                            this.props.updateSintomas(!embarazo, "embarazo")
                          }
                          className="form-check-input"
                          type="checkbox"
                        />
                      </div>
                      <div className="form-check form-check-inline">
                        <label className="form-check-label">No</label>
                        <input
                          style={{ cursor: "pointer" }}
                          checked={!embarazo}
                          onClick={() =>
                            this.props.updateSintomas(!embarazo, "embarazo")
                          }
                          className="form-check-input"
                          type="checkbox"
                        />
                      </div>
                    </div>
                  </div>

                  {embarazo ? (
                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                        {i18next.t("forms.semanasGestacion")}
                      </label>
                      <div className="col-sm-8">
                        <input
                          style={{ cursor: "pointer" }}
                          type="text"
                          className={
                            semanasGestacion <= 0 || semanasGestacion > 45
                              ? "form-control formularioSolicitud--input formularioSolicitud--input-error "
                              : "form-control formularioSolicitud--input"
                          }
                          value={semanasGestacion}
                          onChange={() => this.props.handleInput(event)}
                          name="SemanasGestacion"
                          maxLength={2}
                        />
                        {semanasGestacion == null || semanasGestacion == 0 ? (
                          <p className="formularioSolicitud--input-errorLabel">
                            {i18next.t("forms.gestacionError")}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  ) : null}

                  <div className="form-group row">
                    <label className="col-sm-12 col-form-label formularioSolicitud--text-aligned">
                      {i18next.t("forms.form1Pregunta1")}
                    </label>

                    {/* <div className="col-sm-12 col-form-label formularioSolicitud--text-aligned ">
                                        <label>{this.state.form1Pregunta1 ? "Si" : "No"}</label>
                                        <Switch onColor="#ff6600" onChange={() => this.setState({ form1Pregunta1: !this.state.form1Pregunta1 }, () => this.handleModalMessage())} checked={this.state.form1Pregunta1} />
                                        </div> */}

                    <div className="col-sm-12 col-form-label formularioSolicitud--text-aligned ">
                      <div className="form-check form-check-inline">
                        <label
                          className="form-check-label"
                          for="inlineCheckbox1"
                        >
                          Si
                        </label>
                        <input
                          style={{ cursor: "pointer" }}
                          checked={pregunta1}
                          onClick={() =>
                            this.props.updateSintomas(!pregunta1, "sintoma1")
                          }
                          className="form-check-input"
                          type="checkbox"
                        />
                      </div>
                      <div className="form-check form-check-inline">
                        <label
                          className="form-check-label"
                          for="inlineCheckbox1"
                        >
                          No
                        </label>
                        <input
                          style={{ cursor: "pointer" }}
                          checked={!pregunta1}
                          onClick={() =>
                            this.props.updateSintomas(!pregunta1, "sintoma1")
                          }
                          className="form-check-input"
                          type="checkbox"
                        />
                      </div>
                    </div>
                  </div>

                  {pregunta1 ? (
                    <div className="form-group row">
                      <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                        {i18next.t("forms.fechaContagio")}
                      </label>
                      <div className="col-sm-8">
                        <input
                          style={{ cursor: "pointer" }}
                          type="date"
                          max={moment().format("YYYY-MM-DD")}
                          name="FechaRelacionContacto"
                          value={fechaRelacionContacto}
                          className={
                            fechaRelacionContacto >
                            moment().format("YYYY-MM-DD")
                              ? "formularioSolicitud--date formularioSolicitud--dropDown formularioSolicitud--input formularioSolicitud--input-error"
                              : "formularioSolicitud--date formularioSolicitud--dropDown formularioSolicitud--input"
                          }
                          onChange={() => this.props.handleInput(event)}
                          onFocus={() => this.props.handleInput(event)}
                        />
                        {fechaRelacionContacto >
                        moment().format("YYYY-MM-DD") ? (
                          <p className="formularioSolicitud--input-errorLabel">
                            {i18next.t("forms.errorFecha")}
                          </p>
                        ) : null}
                      </div>
                    </div>
                  ) : null}

                  <div className="form-group row">
                    <label className="col-sm-12 col-form-label formularioSolicitud--text-aligned">
                      {i18next.t("forms.form1Pregunta2")}
                    </label>
                    <div className="col-sm-12 col-form-label formularioSolicitud--text-aligned ">
                      <div className="form-check form-check-inline">
                        <label className="form-check-label">Si</label>
                        <input
                          style={{ cursor: "pointer" }}
                          checked={pregunta2}
                          onClick={() =>
                            this.props.updateSintomas(!pregunta2, "sintoma2")
                          }
                          className="form-check-input"
                          type="checkbox"
                        />
                      </div>
                      <div className="form-check form-check-inline">
                        <label className="form-check-label">No</label>
                        <input
                          style={{ cursor: "pointer" }}
                          checked={!pregunta2}
                          onClick={() =>
                            this.props.updateSintomas(!pregunta2, "sintoma2")
                          }
                          className="form-check-input"
                          type="checkbox"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-sm-12 col-form-label formularioSolicitud--text-aligned">
                      {i18next.t("forms.form1Pregunta3")}
                    </label>
                    <div className="col-sm-12 col-form-label formularioSolicitud--text-aligned ">
                      <div className="form-check form-check-inline">
                        <label className="form-check-label">Si</label>
                        <input
                          style={{ cursor: "pointer" }}
                          checked={pregunta3}
                          onClick={() =>
                            this.props.updateSintomas(!pregunta3, "sintoma3")
                          }
                          className="form-check-input"
                          type="checkbox"
                        />
                      </div>
                      <div className="form-check form-check-inline">
                        <label className="form-check-label">No</label>
                        <input
                          style={{ cursor: "pointer" }}
                          checked={!pregunta3}
                          onClick={() =>
                            this.props.updateSintomas(!pregunta3, "sintoma3")
                          }
                          className="form-check-input"
                          type="checkbox"
                        />
                      </div>
                    </div>
                  </div>

                  {this.props.grupoFamiliar.length > 0 &&
                  (pregunta1 || pregunta2 || pregunta3) ? (
                    <div>
                      <div
                        dangerouslySetInnerHTML={this.handleGenericHtml(
                          i18next.t("table.tituloTablaBeneficiario")
                        )}
                      />

                      <table className="historicoTable table table-hover table-bordered">
                        <thead>
                          <tr>
                            <th width="50%" className="historicoTable--title">
                              {i18next.t("table.beneficiario")}
                            </th>
                            <th className="historicoTable--title">
                              {i18next.t("table.convivencia")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.props.grupoFamiliar?.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item.Nombre}</td>
                                <td>
                                  <input
                                    style={{ cursor: "pointer" }}
                                    type="checkbox"
                                    checked={item.isChecked}
                                    onClick={() =>
                                      this.props.handleConvivenciaBeneficiario(
                                        item,
                                        index
                                      )
                                    }
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ) : null}
                  {pregunta1 || pregunta2 || pregunta3 ? (
                    <div>
                      {/* {console.log(i18next.t("forms.beneficiario"))} */}
                      <h3>
                        {" "}
                        {i18next.t("forms.beneficiario")}
                        <a
                          style={{ cursor: "pointer" }}
                          data-toggle="collapse"
                          data-target="#demo"
                        >
                          aquí
                        </a>
                      </h3>

                      <div id="demo" className="collapse">
                        <AddContactos
                          tableValidated={this.handleContactosTable}
                          documentos={idList}
                          submitInfo={this.state.contactosTableContinue}
                          nombre={nombre}
                          tipoId={id}
                          ciudad={this.props.ciudad}
                          numeroDocumento={idNum}
                          plan={this.props.plan}
                          handleGenericHtml={this.handleGenericHtml}
                        />
                      </div>
                    </div>
                  ) : null}

                  {/* <div className="form-group row">
                                        <br></br>
                                        <div className="center-block" style={{ width: "240px" }}>
                                            <label className="checkbox-inline center-block"><input type="checkbox" checked={aceptaTC} /><a onChange={() => this.props.handleTerminosCondiciones()}>Acepto términos y condiciones</a></label>
                                        </div>
                                    </div> */}

                  <div className="form-group row">
                    <div className="center-block" style={{ width: "400px" }}>
                      <div className="checkbox-inline center-block">
                        <div className="cotizar-form-controls btn-terminosCondiciones">
                          <button
                            onClick={(event) => {
                              event.preventDefault();
                              this.props.handleTerminosCondiciones(true);
                            }}
                            className={`cotizar-form-controls-action ${
                              aceptaTC ? "active" : null
                            }`}
                          >
                            Si
                          </button>
                          <button
                            onClick={(event) => {
                              event.preventDefault();
                              this.props.handleTerminosCondiciones(false);
                            }}
                            className={`cotizar-form-controls-action ${
                              !aceptaTC ? "active" : null
                            }`}
                          >
                            No
                          </button>
                        </div>
                        <label style={{ width: "200px" }}>
                          Autorización del tratamiento de los datos personales
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="form-group row">
                    <div className="center-block" style={{ width: "400px" }}>
                      <div className="checkbox-inline center-block">
                        <div className="cotizar-form-controls  btn-terminosCondiciones">
                          <button
                            onClick={(event) => {
                              event.preventDefault();
                              this.props.handleAceptaRecibirInformacion(true);
                            }}
                            className={`cotizar-form-controls-action ${
                              this.props.aceptaRecibirInformacion
                                ? "active"
                                : null
                            }`}
                          >
                            Si
                          </button>
                          <button
                            onClick={(event) => {
                              event.preventDefault();
                              this.props.handleAceptaRecibirInformacion(false);
                            }}
                            className={`cotizar-form-controls-action ${
                              !this.props.aceptaRecibirInformacion
                                ? "active"
                                : null
                            }`}
                          >
                            No
                          </button>
                        </div>
                        <label style={{ width: "200px" }}>
                          Acepto recibir informacion de Compensar en mi correo
                          electronico, sms, whatsapp y comunicaciones fisicas
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <br></br>
                    <div className="col-sm-12 text-center">
                      <button
                        type="button"
                        className="btn btn-default"
                        // onChange={() => this.getFechaDescargaCertificado("TemasCovid19-Riesgos")}
                        onClick={() => {
                          this.props.handleSubmit("TemasCovid19-Riesgos", null, 0),
                            this.setState({
                              contactosTableContinue: "submit",
                              departamentoSelected: null,
                              ciudadSelected: null,
                            });
                        }}
                        disabled={
                          nombre == null ||
                          nombre == "" ||
                          id == null ||
                          id == "elija un documento" ||
                          idNum == null ||
                          idNum == "" ||
                          email == null ||
                          emailIsValid == null ||
                          emailIsValid == false ||
                          celular == null ||
                          celular == "" ||
                          direccion == null ||
                          direccion == "" ||
                          ciudad == null ||
                          departamento == "" ||
                          departamento == " " ||
                          departamento == null ||
                          this.state.departamentoSelected == "" ||
                          this.state.departamentoSelected == " " ||
                          this.state.departamentoSelected == null ||
                          ciudad == "" ||
                          aceptaTC == false ||
                          (pregunta1 && fechaRelacionContacto == null) ||
                          this.state.contactosTableContinue == false
                            ? true
                            : false
                        }
                      >
                        {i18next.t("forms.buttonSubmit")}
                      </button>
                    </div>
                  </div>
                </form>

                <p>
                  {i18next.t("forms.ips")}
                  <a onClick={() => this.props.handleCollapse()}>aquí</a>
                </p>
                <Collapse in={collapse}>
                  <div>
                    <Well>
                      <form
                        onSubmit={(event) => {
                          event.preventDefault();
                        }}
                      >
                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label formularioSolicitud--text-aligned">
                            {i18next.t("forms.ipsLabel")}
                          </label>
                          <div className="col-sm-8">
                            <button
                              style={{ cursor: "pointer" }}
                              className="dropdown-toggle formularioSolicitud--dropDown formularioSolicitud--dropDown-none"
                              // type="button"
                              id="dropdowTipoHistoria"
                              // data-toggle="dropdown"
                              // aria-haspopup="true"
                              // aria-expanded="false"
                              onClick={() =>
                                this.setState({
                                  visibleSelectorIps:
                                    !this.state.visibleSelectorIps,
                                })
                              }
                            >
                              <div>
                                <p className="text-left">{ips}</p>
                              </div>
                              <span className="caret"></span>
                              <ul
                                className="dropdown-menu"
                                aria-label="Seleccione Si o No segun su condiciòn si fue expedido o no "
                                style={{
                                  cursor: "pointer",
                                  display: `${
                                    this.state.visibleSelectorIps
                                      ? "block "
                                      : "none"
                                  }`,
                                }}
                              >
                                {ipsList?.map((item, index) => {
                                  return (
                                    <li
                                      key={index}
                                      onClick={() => {
                                        this.setState({
                                          visibleSelectorIps: false,
                                        });
                                        this.props.handleIps(item);
                                      }}
                                    >
                                      <p>{item}</p>
                                    </li>
                                  );
                                })}
                              </ul>
                            </button>
                          </div>
                        </div>

                        <p className="text-center">
                          {i18next.t("forms.medico")}
                        </p>

                        <div className="form-group row">
                          <div className="col-sm-4">
                            <p className="col-form-label formularioSolicitud--text-aligned formularioSolicitud--label">
                              {i18next.t("forms.cedula")}
                            </p>
                            <p className="formularioSolicitud--text-aligned">
                              {i18next.t("forms.cedulaIndicacion")}
                            </p>
                          </div>
                          <div className="col-sm-3">
                            <button
                              disabled={false}
                              style={{ cursor: "pointer" }}
                              className="dropdown-toggle formularioSolicitud--dropDown"
                              // type="button"
                              id="dropdownCedula"
                              // data-toggle="dropdown"
                              // aria-haspopup="true"
                              // aria-expanded="true"
                              onClick={() =>
                                this.setState({
                                  visibleSelectorMedicoDocumento:
                                    !this.state.visibleSelectorMedicoDocumento,
                                })
                              }
                            >
                              <div>
                                <p className="text-left">
                                  {medicoDocument.CSDocumentoIdentidadText}
                                </p>
                              </div>
                              <span className="caret"></span>
                              <ul
                                className="dropdown-menu"
                                aria-labelledby="dropdownCedula"
                                style={{
                                  cursor: "pointer",
                                  display: `${
                                    this.state.visibleSelectorMedicoDocumento
                                      ? "block "
                                      : "none"
                                  }`,
                                }}
                              >
                                {idList?.map((item, index) => {
                                  return (
                                    <li
                                      key={index}
                                      onClick={() => {
                                        this.setState({
                                          visibleSelectorMedicoDocumento: false,
                                        });
                                        this.props.handleMedicodocument(item);
                                      }}
                                    >
                                      <p>{item.CSDocumentoIdentidadText}</p>
                                    </li>
                                  );
                                })}
                              </ul>
                            </button>
                          </div>
                          <div className="col-sm-5">
                            <input
                              style={{ cursor: "pointer" }}
                              disabled={false}
                              type="text"
                              className={
                                "form-control formularioSolicitud--input"
                              }
                              value={medicoDocumentNum}
                              onChange={() => this.props.handleInput(event)}
                              name="NumeroDocumentoMedico"
                              maxLength={33}
                            />
                          </div>
                        </div>
                      </form>
                    </Well>
                  </div>
                </Collapse>
              </div>
            ) : null}
          </div>
        </div>
      </section>
    );
  }
}
